// import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/image.png'
// import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import Esummit from '../assets/esummit.png'


export const projectsData = [
    {
        id: 1,
        projectName: 'Esummit-2024',
        projectDesc: 'An Event Website where user can book tickets view event details.',
        tags: ['Next.js', 'Mongo Atlas', 'Acertinity Ui'],
        code: 'https://github.com/LovkashGarg',
        demo: 'https://esummit24.iiitp.ac.in/',
        image: Esummit
    },
    {
        id: 2,
        projectName: 'FusionSpace',
        projectDesc: 'A Collabrative Workspace for all the teams which want to contribute and edit files in real-time in a synchronized way .',
        // projectDesc: 'This project aims to build an employee management system that consolidates all information of a company',
        tags: ['React.js', 'Socket.io', 'Node Js', 'Gen-AI'],
        code: 'https://fusion-space.vercel.app/',
        demo: 'https://fusion-space.vercel.app/',
        image: three
    },
    {
        id: 3,
        projectName: 'EduHome',
        projectDesc: 'This project is a online Learning Platform for all types of Students.',
        tags: ['Mern','ZegoCloud', 'JWT Token'],
        code: 'https://github.com/LovkashGarg/EduHome-Full',
        demo: 'https://drive.google.com/file/d/1IV915kswRdfJmp-g-JEjHQjvFch5OOZh/view',
        image: two
    },
    
   
    
    // {
    //     id: 4,
    //     projectName: 'Android Patient Tracker',
    //     projectDesc: 'This project involves the development of an Android application for viewing and managing patient data.',
    //     tags: ['Flutter', 'Firebase'],
    //     code: 'https://github.com/LovkashGarg',
    //     demo: 'https://github.com/LovkashGarg',
    //     image: four
    // },
    {
        id: 4,
        projectName: 'Acoustic Guard',
        projectDesc: 'A application for security of user 24*7 at Home. ',
        tags: ['Librosa', 'Python'],
        code: 'https://github.com/LovkashGarg/Acoustic-Guard-security_check_system-',
        demo: 'https://github.com/LovkashGarg/Acoustic-Guard-security_check_system-',
        image: five
    },
    // {
    //     id: 6,
    //     projectName: 'Uber Lite',
    //     projectDesc: 'Uber clone',
    //     tags: ['Flutter'],
    //     code: 'https://github.com/LovkashGarg',
    //     demo: 'https://github.com/LovkashGarg',
    //     image: six
    // },
    // {
    //     id: 7,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/LovkashGarg',
    //     demo: 'https://github.com/LovkashGarg',
    //     image: seven
    // },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/LovkashGarg',
    //     demo: 'https://github.com/LovkashGarg',
    //     image: eight
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/